import * as Icons from "lucide-react";
import { CATEGORY_META } from "../lib/api";

export const CategoryIcon = ({ category, className = "w-4 h-4", style }) => {
  const meta = CATEGORY_META[category];
  const Icon = (meta && Icons[meta.icon]) || Icons.Circle;
  return <Icon className={className} strokeWidth={2} style={style} />;
};
